import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/expansionLogin',
        name: 'expansionLogin',
        component: resolve => require(['@/views/expansionDemo/login'], resolve),
        meta: {
          title: '链下扩容',
          breadLevel: 0,
          icon: 'icon-expansion',
          auth: auth.expension
        }
      },
      {
        path: '/expansionDemo',
        name: 'expansionDemo',
        component: resolve => require(['@/views/expansionDemo/index'], resolve),
        meta: {
          title: '扩容通道',
          breadLevel: 1,
          icon: 'icon-expansion',
        }
      },
      {
        path: '/expansionDemo/functionDemo',
        name: 'functionDemo',
        component: resolve => require(['@/views/expansionDemo/functionDemo'], resolve),
        meta: {
          title: '链下扩容扩容',
          breadLevel: 2,
          icon: 'icon-expansion'
        }
      }
    ]
  }
]

export default routes
